import AuthLogin from "../../components/Auth/LoginStaffSdc";

export default function Auth() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AuthLogin/>
    </div>
  );
}
